import React from 'react';

export default function options({ height }) {
  return (
    <svg height={height || '19'} viewBox="0 0 18 19" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 13.9092C10.1046 13.9092 11 14.8046 11 15.9092C11 17.0137 10.1046 17.9092 9 17.9092C7.89543 17.9092 7 17.0137 7 15.9092C7 14.8046 7.89543 13.9092 9 13.9092ZM9 7.90918C10.1046 7.90918 11 8.80461 11 9.90918C11 11.0137 10.1046 11.9092 9 11.9092C7.89543 11.9092 7 11.0137 7 9.90918C7 8.80461 7.89543 7.90918 9 7.90918ZM9 1.90918C10.1046 1.90918 11 2.80461 11 3.90918C11 5.01375 10.1046 5.90918 9 5.90918C7.89543 5.90918 7 5.01375 7 3.90918C7 2.80461 7.89543 1.90918 9 1.90918Z"
        fill="currentColor"
      />
    </svg>
  );
}
